import { useNavigate, useParams } from "react-router-dom";

import { Paper, Text } from "@mantine/core";

import { motion } from "framer-motion";

import { usePerformRequest } from "../../Lib/usePerformRequest";
import { NonPaginatedResponse } from "../../Lib/Responses";
import { UserProfile } from "../../Lib/Types";
import { Endpoints } from "../../Lib/Endpoints";

import "./styles.scss";
import {
  AppName,
  Colors,
  EmailUnVerifiedImage,
  EmailVerifiedImage,
  LogoFull,
  LogoM,
} from "../../Lib/Data";
import MegaLoader from "../../Components/MegaLoader";
import { useEffect } from "react";
import { DefaultSuccessNotification } from "../../Lib/Methods";

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const { verificationID, verificationToken } = useParams() as {
    verificationID: string;
    verificationToken: string;
  };

  document.title = `Confirm your Email| ${AppName}`;

  const { data, isLoading, response } = usePerformRequest<
    NonPaginatedResponse<UserProfile>
  >({
    method: "GET",
    route: Endpoints.GetUserVerifyEmail(verificationID, verificationToken),
  });

  useEffect(() => {
    if (response && response.status === 200) {
      DefaultSuccessNotification("Your email has been verified!");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    }
  }, [response]);
  return (
    <div className="verify-email-container">
      <div className="content-wrapper">
        <div className="img-container">
          <img src={LogoM} alt="Logo" className="logo" />
        </div>
        <Paper className="verify-card">
          <motion.div
            initial={false}
            animate={{
              minHeight: isLoading ? "180px" : "280px",
            }}
            className="flex-col align-center justify-center w-full"
          >
            {isLoading ? (
              <MegaLoader />
            ) : (
              <>
                {response && response.status && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4 }}
                    className="flex-col align-center"
                  >
                    <img
                      className="response-image"
                      src={
                        response.status === 200
                          ? EmailVerifiedImage
                          : EmailUnVerifiedImage
                      }
                      alt=""
                    />
                    <Text
                      fw={700}
                      size="lg"
                      c={
                        response.status === 200
                          ? Colors.GreenSecondary
                          : Colors.RedPrimary
                      }
                    >
                      {response.status === 200
                        ? "Email Verified Successfully"
                        : "Verification Failed"}
                    </Text>
                    <Text c="dimmed" size="sm" mt="xs" fw={500}>
                      {response.status === 200
                        ? "Redirecting you to login..."
                        : "The link might be invalid or expired"}
                    </Text>
                  </motion.div>
                )}
              </>
            )}
          </motion.div>
        </Paper>
      </div>
    </div>
  );
}
